import { Dispatch, SetStateAction } from 'react';

import { NOTIFICATION_FLAGS } from '@app/dashboard/constants/settings/notifications';
import {
  TMerchantFlags,
  TNotificationFlags,
} from '@app/dashboard/types/innerLayout/notifications';

export const formatMerchantFlags = (flags: { [key: string]: boolean }[]) => {
  if (!flags) return {};
  const formattedFlags: { [key: string]: boolean } = {};

  flags.forEach((flag) => {
    const key = Object.keys(flag)[0];
    formattedFlags[key] =
      key === NOTIFICATION_FLAGS.SKIP_CUSTOMER_TRANSACTION_EMAIL
        ? !flag[key]
        : flag[key];
  });

  return formattedFlags;
};

export const formatEmails = (emails: { email: string }[]) => {
  if (!emails) return [];

  return emails.map((item) => item.email);
};

export const checkIfSaveChangesDisabled = ({
  merchantFlags,
  updatedFlags,
}: {
  merchantFlags: TMerchantFlags;
  updatedFlags: TMerchantFlags;
}) => {
  const flagsKeys = Object.keys(updatedFlags) as TNotificationFlags[];

  return flagsKeys.every((key) => merchantFlags[key] === updatedFlags[key]);
};
